import { Navigate, Outlet } from 'react-router-dom'

import { useIsAccountingPageAccessible } from 'hooks/utils/isAccountingPageAccessible'
import { ListRoutes } from 'layouts/app/useLeftRailItems'

const AccountingRouteGuard = () => {
  const isAccessible = useIsAccountingPageAccessible()

  if (!isAccessible) {
    return <Navigate to={ListRoutes.Dashboard} replace />
  }

  return <Outlet />
}

export default AccountingRouteGuard
